/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { numCol, strCol } from '@integec/grid-tools/lib/cols'
import moment from 'moment'
import Grid from '@integec/grid-tools/lib/Grid'
import {
  defaultVirtualizedCellRender,
  freeEditEngine,
  VirtualizedCell,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import { connect } from 'react-redux'
import { getApiTargetInfo, getUnits, timeZoneIdentMap } from 'core'
import { BKFConversionFactorEffective } from 'api/pgads'
import R from 'ramda'
import {
  Button,
  DatePicker,
  Input,
  InputNumber,
  message,
  Modal,
  Tooltip,
} from 'antd'
import { addRow, removeRow } from '@integec/grid-tools/lib/editEngine'
import { rowHeaderRender } from 'core/utils'
import numeral from 'numeral'

const SpillTable = ({
  height = 300,
  width = 920,
  // units,
  // onEdit,
  data,
  allData,
  targetInfo,
  handleExtSave,
  handleChange,
  mode,
  disableComp,
  // disableCOPUEVentTypeView,
}) => {
  const {
    spillData = [],
    editInfo = freeEditEngine.generateInitialEditInfo(),
  } = data
  const {
    unit,
    utility,
    year,
    eventNum,
    extension,
    extensionData,
    eventStart,
    eventEnd,
    spillRowSelection = [],
    eventStartZone,
    spillValidation = [],
    dataModified = false,
  } = allData

  const [factorList, setFactorList] = useState([])

  const getFactorBySpillDate = useCallback(
    dateStr => {
      const factor = (factorList || [])
        .filter(f => {
          const eff = moment(f.effectiveDate)
          const dt = moment(dateStr)
          return dt.isSameOrAfter(eff)
        })
        .map(d => ({ ...d, momEff: moment(d.effectiveDate) }))

      let latest = factor.length > 0 ? factor[0] : {}
      if (factor.length > 1) {
        const max = moment.max(factor.map(d => d.momEff))
        latest = factor.find(d => d.momEff.isSame(max))
      }

      return (latest && latest.conversionFactor) || undefined
    },
    [factorList]
  )
  const [insertData, setInsertData] = useState({
    visible: false,
  })

  useEffect(
    _ => {
      // const spillData = (extension || {} || extensionData || {}).spillData || []
      const spillDatafinal = freeEditEngine.applyEdits({
        data: spillData || [],
        editInfo: editInfo || freeEditEngine.generateInitialEditInfo(),
      })

      const getMAxDate = _ => {
        if (spillDatafinal.length <= 0)
          return moment(
            eventStart,
            'YYYY-MM-DDTHH:mm:ss.SSS',
            timeZoneIdentMap[eventStartZone]
          )

        // const endDates = spillData.map(d =>
        //   moment(d.spillEnd || eventStart, 'YYYY-MM-DDTHH:mm:ss.SSS').tz(
        //     timeZoneIdentMap[eventStartZone]
        //   )
        // )
        const endDates = spillDatafinal.map(d => d.spillEndMod || eventStart)
        const maxDate = R.reduce(
          (a, b) => (moment(a).isAfter(moment(b)) ? moment(a) : moment(b)),
          moment(eventStart),
          endDates
        )
        // const maxDate = moment.max(...endDates)
        // const nd = moment.tz(
        //   maxDate.format('YYYY-MM-DDTHH:mm:ss.SSS'),
        //   timeZoneIdentMap[eventStartZone]
        // )

        return maxDate
      }

      const gmdt = getMAxDate()
      const effDate = moment(
        gmdt || moment(eventStart, timeZoneIdentMap[eventStartZone])
      )

      if (!effDate.isValid()) {
        setInsertData({})
      }

      if (effDate && effDate.isValid()) {
        const dt = moment(effDate).clone()

        const fac = getFactorBySpillDate(
          moment(effDate).format('YYYY-MM-DDTHH:mm:ss.SSS')
        )
        let eds = {}
        if (eventEnd && spillDatafinal.length === 0) {
          const et = moment(eventEnd).clone()
          eds = {
            spillEndMod: et.format('MM/DD/YYYY HH:mm'),
            spillEndModDate: et,
            durHr: getDurHr(dt, et),
          }
        }
        setInsertData({
          spillStartMod: dt.format('MM/DD/YYYY HH:mm'),
          spillStartModDate: dt.clone(),
          overwriteFactor: fac,
          defaultFactor: fac,
          ...eds,
        })
      }
    },
    [
      eventEnd,
      eventStart,
      eventStartZone,
      extension,
      extensionData,
      getFactorBySpillDate,
      // spillData,
      // editInfo,
    ]
  )

  const setEditInfo = editInfo => {
    handleExtSave('editInfo', editInfo)
    handleChange({ name: 'spillValidation', value: [] })
  }

  const checkValidation = _ => {
    let spillDataValidation = freeEditEngine.applyEdits({
      data: spillData || [],
      editInfo: editInfo || freeEditEngine.generateInitialEditInfo(),
    })

    spillDataValidation = spillDataValidation.map(d => ({
      ...d,
      spillStart: moment
        .tz(
          moment(d.spillStartMod, 'MM/DD/YYYY HH:mm').format(
            'YYYY-MM-DDTHH:mm:ss'
          ),
          timeZoneIdentMap[eventStartZone]
        )
        .second(0)
        // .utc()
        // .tz(timeZoneIdentMap[this.state.eventStartZone])
        .format('YYYY-MM-DDTHH:mm:ss'),
      spillEnd: moment
        .tz(
          moment(d.spillEndMod, 'MM/DD/YYYY HH:mm').format(
            'YYYY-MM-DDTHH:mm:ss'
          ),
          timeZoneIdentMap[eventStartZone]
        )
        .second(0)
        // .utc(d.spillEndMod, 'MM/DD/YYYY HH:mm')
        // .utc()
        // .tz(timeZoneIdentMap[this.state.eventStartZone])
        .format('YYYY-MM-DDTHH:mm:ss'),
    }))

    const valError = []

    // R.sortWith(
    //   (a, b) => (a && b && moment(a.spillStart) - moment(b.spillStart)) || 0,
    //   spillDataValidation
    // )
    const sortspillDAta = [...(spillDataValidation || [])].sort(
      (a, b) => (a && b && moment(a.spillStart) - moment(b.spillStart)) || 0
    )
    sortspillDAta.forEach((valData, idx) => {
      const {
        spillStart,
        spillEnd,
        overwriteFactor,
        flowRate,
        spillStartMod,
        spillEndMod,
      } = valData

      const rowNum = idx + 1

      if (!moment(spillStart).isValid())
        valError.push('Start is required Field-{' + rowNum + '}')
      if (!moment(spillEnd).isValid())
        valError.push('End is required Field-{' + rowNum + '}')
      if (
        R.isNil(overwriteFactor) ||
        isNaN(overwriteFactor) ||
        (overwriteFactor ? overwriteFactor + '' : '').trim().length <= 0
      )
        valError.push('eFactor is required Field-{' + rowNum + '}')
      if (
        R.isNil(flowRate) ||
        isNaN(flowRate) ||
        (flowRate ? flowRate + '' : '').trim().length <= 0
      )
        valError.push('Flow Rate is required Field-{' + rowNum + '}')
      if (
        moment(spillStart)
          .second(0)
          .isAfter(moment(spillEnd).second(0))
      )
        valError.push('Start cannot be after End-{' + rowNum + '}')
      // moment(eventStart).isAfter(moment(spillStart)) ||
      // moment(eventEnd).isBefore(moment(spillEnd)) ||
      // moment(eventStart).isAfter(moment(spillEnd))
      //  || moment(eventEnd).isBefore(moment(spillStart))

      const spillZoneDate = moment
        .tz(spillStartMod, 'MM/DD/YYYY HH:mm', timeZoneIdentMap[eventStartZone])
        .second(0)
      const spillEndZoneDate = moment
        .tz(spillEndMod, 'MM/DD/YYYY HH:mm', timeZoneIdentMap[eventStartZone])
        .second(0)

      const eventStartZoneDate = moment
        .tz(eventStart, 'YYYY-MM-DDTHH:mm:ss', timeZoneIdentMap[eventStartZone])
        .second(0)
      const eventEndZoneDate = moment
        .tz(
          moment(eventEnd).format('YYYY-MM-DDTHH:mm:ss'),
          'YYYY-MM-DDTHH:mm:ss',
          timeZoneIdentMap[eventStartZone]
        )
        .second(0)

      if (
        eventEndZoneDate.isValid() &&
        (!spillZoneDate
          .clone()
          // .add(1, 's')
          .isBetween(eventStartZoneDate, eventEndZoneDate, undefined, []) ||
          !spillEndZoneDate
            .clone()
            // .subtract(1, 's')
            .isBetween(eventStartZoneDate, eventEndZoneDate, undefined, []))
      ) {
        valError.push(
          'You are about to extend the spill entry beyond the start/end of its related outage.-{' +
            rowNum +
            '}'
        )
      }

      const maxEndZoneDate = moment
        .tz(
          spillZoneDate.format('YYYYMM') + '01000000',
          'YYYYMMDDHHmmss',
          timeZoneIdentMap[eventStartZone]
        )
        .add(1, 'M')

      if (spillEndZoneDate.isAfter(maxEndZoneDate))
        valError.push(
          `Spill entries may not span across multiple calendar months..-{${rowNum}}`
        )
    })

    const isEqual = R.equals(spillValidation, valError)
    if (!isEqual) {
      handleChange(
        { name: 'spillValidation', value: valError },
        dataModified || false
      )
    }
  }

  useEffect(checkValidation, [
    editInfo,
    eventEnd,
    eventStart,
    eventStartZone,
    spillData,
    spillValidation,
    handleChange,
    dataModified,
  ])

  // const [selectedRows, setSelectedRows] = useState({})
  const setSelectedRows = selection => {
    const isEqual = R.equals(spillRowSelection, selection.selectedRows)

    if (!isEqual)
      handleChange({ name: 'spillRowSelection', value: selection.selectedRows })
  }

  useEffect(
    _ => {
      BKFConversionFactorEffective(targetInfo)(unit).fork(
        _ => setFactorList([]),
        allFactor => {
          const sortedFactor = R.sort((a, b) => {
            return moment(a.effectiveDate).isSameOrAfter(
              moment(b.effectiveDate)
            )
              ? 0
              : 1
          }, allFactor)

          setFactorList(sortedFactor)
        }
      )
    },
    [targetInfo, unit]
  )

  const getDurHr = (spillStartMod, spillEndMod) => {
    if (spillEndMod && spillStartMod) {
      let diff = spillEndMod.diff(spillStartMod, 'm')
      if (diff !== 0 && !isNaN(diff)) {
        diff = diff / 60
        if (!isNaN(diff)) {
          return numeral(diff).format('#.0000')
        }
      }
    }
    return undefined
  }

  const editRow = newEditInfo => {
    setEditInfo(newEditInfo)
  }

  const removeSelectedRows = _ => {
    if (spillRowSelection.length <= 0) return
    let effEditInfo = { ...editInfo }
    spillRowSelection.forEach(row => {
      effEditInfo = removeRow({ editInfo: effEditInfo, currentRow: row })
    })
    setEditInfo(effEditInfo)
    checkValidation()
  }

  // const insertSpill = _ => {
  //   const saveData = freeEditEngine.applyEdits({
  //     data: spillData,
  //     editInfo,
  //   })

  //   const spillStart =
  //     (saveData[saveData.length - 1] &&
  //       saveData[saveData.length - 1].spillEndMod &&
  //       moment(saveData[saveData.length - 1].spillEndMod).format(
  //         'YYYY-MM-DDTHH:mm:ss.SSS'
  //       )) ||
  //     eventStart
  //   const spillEnd = saveData[saveData.length - 1] ? undefined : eventEnd
  //   const defaultFactor = getFactorBySpillDate(spillStart)
  //   const spillStartMod = moment(spillStart)
  //     // .utc()
  //     // .tz(timeZoneIdentMap[timeZone])
  //     .format('MM/DD/YYYY HH:mm')
  //   const spillEndMod =
  //     spillEnd &&
  //     moment(spillEnd)
  //       // .utc()
  //       // .tz(timeZoneIdentMap[timeZone])
  //       .format('MM/DD/YYYY HH:mm')
  //   // const durHr = getDurHr(moment(spillStart), moment(spillEnd))
  //   const newSpill = {
  //     unitId: unit,
  //     utility,
  //     unit: unit.substr(3),
  //     year,
  //     eventNum,
  //     defaultFactor,
  //     overwriteFactor: defaultFactor,
  //     spillStart,
  //     spillEnd,
  //     spillStartMod,
  //     spillEndMod,
  //     // durHr,
  //   }
  //   const nEditInfo = addRow({ editInfo, editedRow: newSpill })

  //   setEditInfo(nEditInfo)
  //   // checkValidation()
  // }

  const getMWH = (flowRate, factor, dur) => {
    if (!isNaN(flowRate) && !isNaN(factor) && !isNaN(dur)) {
      const v = Number(flowRate * factor * dur)
      if (!isNaN(v)) {
        return (v || 0).toFixed(2)
      }
    }
    return null
  }

  const cellRender = props => {
    const { gridToolProps, reactVirtualizedProps } = props
    const { getCellProps, headers, data } = gridToolProps
    const { columnIndex, rowIndex, style } = reactVirtualizedProps

    const {
      defaultFactor,
      overwriteFactor,
      flowRate,
      // spillStart,
      // spillEnd,
      spillEndMod,
      spillStartMod,
    } = data[rowIndex]
    const durHr = getDurHr(moment(spillStartMod), moment(spillEndMod))

    const headerIdent = headers[columnIndex].ident

    const cellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })
    if (cellProps.isEditing) {
      return defaultVirtualizedCellRender({
        ...props,
      })
    }

    const overStyle = {
      ...style,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      borderTop: '1px solid #cc',
      backgroundColor: cellProps.isSelected ? '#F8F8F8' : 'white',
      color: cellProps.isSelected ? 'black' : undefined,
    }

    if (headerIdent === 'durHr') {
      //  if (flowRate && factor && durHr)
      // const mwhStyle = { ...overStyle, color: '#0000ff', fontWeight: '700' }
      return (
        <VirtualizedCell {...props} {...cellProps}>
          {isNaN(durHr) ? '' : parseFloat(durHr).toFixed(2)}
        </VirtualizedCell>
      )
    }
    if (headerIdent === 'overwriteFactor') {
      //  if (flowRate && factor && durHr)
      const factorStyle = {
        ...overStyle,
        color: overwriteFactor === defaultFactor ? overStyle.color : '#e53935',
        fontWeight: overwriteFactor === defaultFactor ? 'black' : '700',
      }

      return (
        <VirtualizedCell {...props} {...cellProps} style={factorStyle}>
          {overwriteFactor}
        </VirtualizedCell>
      )
    }
    if (headerIdent === 'mwh') {
      //  if (flowRate && factor && durHr)
      const mwhStyle = { ...overStyle, color: '#0000ff', fontWeight: '700' }
      const mwhValue = getMWH(flowRate, overwriteFactor, durHr)
      return (
        <VirtualizedCell {...props} {...cellProps} style={mwhStyle}>
          {isNaN(mwhValue) ? '' : mwhValue}
        </VirtualizedCell>
      )
    }

    // const style = reactVirtualizedProps.style
    return defaultVirtualizedCellRender({
      ...props,
      style: overStyle,
    })
  }

  const showValidationModal = _ => {
    Modal.info({
      title: 'Spill Validation - {Row Number}',
      content: (
        <div style={{ maxHeight: '300px', overflow: 'auto' }}>
          <ol>
            {spillValidation.map(v => (
              <li key={v}>{v}</li>
            ))}
          </ol>
        </div>
      ),
      width: 500,
      onOk() {},
    })
  }

  const firstValidationText = useMemo(
    _ => {
      const nonWarningfirst = (spillValidation || []).find(
        f => !f.includes('WARNING')
      )
      if (nonWarningfirst) return nonWarningfirst
      else return spillValidation[0] || ''
    },
    [spillValidation]
  )

  return (
    <div
      style={{
        height: height + 'px',
        width: width + 'px',
        display: 'grid',
        gridTemplateRows: 'min-content min-content auto',
        marginTop: '10px',
      }}
    >
      <div
        style={{
          gap: '10px',
          marginTop: '20px',
          marginBottom: '5px',
          display: 'flex',
        }}
      >
        {/* <Button
          onClick={insertSpill}
          disabled={disableComp || disableCOPUEVentTypeView}
          type="primary"
        >
          New Spill
        </Button> */}
        <Button
          onClick={removeSelectedRows}
          disabled={
            // disableComp ||
            // disableCOPUEVentTypeView ||
            spillRowSelection.length <= 0
          }
          type="danger"
        >
          Remove Selected Spill
        </Button>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '90% 10%',
            gridColumnGap: '5px',
            width: '100%',
          }}
        >
          <Input disabled value={firstValidationText} />

          <Tooltip title="View All Validation">
            <Button
              icon="eye"
              onClick={showValidationModal}
              disabled={
                disableComp ||
                // disableCOPUEVentTypeView ||
                spillValidation.length <= 0
              }
            />
          </Tooltip>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 200px 120px 100px 150px 100px 150px',
          margin: 5,
          gap: 5,
        }}
      >
        <Tooltip title="Start DateTime" placement="left">
          <DatePicker
            allowClear={false}
            title="Start"
            showTime={{
              format: 'h:mm',
              defaultValue: moment('00:00', 'HH:mm'),
            }}
            format="MM/DD/YYYY HH:mm"
            placeholder="Start DateTime"
            value={insertData.spillStartModDate}
            onChange={ndate => {
              if (ndate) {
                const date = ndate.clone().second(0)
                const defaultFactor = getFactorBySpillDate(
                  date.format('YYYY-MM-DDTHH:mm:ss.SSS')
                )
                const spillStartMod = date.format('MM/DD/YYYY HH:mm')
                const durHr = getDurHr(
                  moment(date),
                  insertData.spillEndMod
                    ? moment(insertData.spillEndMod)
                    : undefined
                )
                const mwhValue = getMWH(
                  insertData.flowRate,
                  insertData.overwriteFactor,
                  durHr
                )
                setInsertData({
                  ...insertData,
                  overwriteFactor: insertData.overwriteFactorManualUpdate
                    ? insertData.overwriteFactor || defaultFactor
                    : defaultFactor,
                  defaultFactor,
                  spillStartMod,
                  spillStartModDate: date,
                  durHr,
                  mwh: mwhValue,
                })
              }
            }}
          />
        </Tooltip>
        <Tooltip title="End DateTime">
          <DatePicker
            allowClear={false}
            showTime={{
              format: 'h:mm',
              defaultValue: moment('00:00', 'HH:mm'),
            }}
            format="MM/DD/YYYY HH:mm"
            placeholder="End DateTime"
            value={insertData.spillEndModDate}
            onChange={ndate => {
              if (ndate) {
                const date = ndate.clone().second(0)
                const spillEndMod = date.format('MM/DD/YYYY HH:mm')
                const durHr = getDurHr(
                  moment(insertData.spillStartMod),
                  moment(spillEndMod)
                )
                const mwhValue = getMWH(
                  insertData.flowRate,
                  insertData.overwriteFactor,
                  durHr
                )
                setInsertData({
                  ...insertData,
                  spillEndMod,
                  spillEndModDate: date,
                  durHr,
                  mwh: mwhValue,
                })
              }
            }}
          />
        </Tooltip>
        <Tooltip title="Flow Rate/Hr">
          <InputNumber
            style={{ width: '100%' }}
            placeholder="Flow Rate/Hr"
            value={insertData.flowRate}
            onChange={val => {
              const mwhValue = getMWH(
                val,
                insertData.overwriteFactor,
                insertData.durHr
              )

              setInsertData({ ...insertData, flowRate: val, mwh: mwhValue })
            }}
          />
        </Tooltip>
        <Tooltip title="eFactor">
          <InputNumber
            placeholder="eFactor"
            value={insertData.overwriteFactor}
            onChange={val => {
              const mwhValue = getMWH(
                insertData.flowRate,
                val,
                insertData.durHr
              )
              setInsertData({
                ...insertData,
                overwriteFactor: val,
                overwriteFactorManualUpdate: true,
                mwh: mwhValue,
              })
            }}
            style={{
              color:
                !isNaN(insertData.defaultFactor) &&
                !isNaN(insertData.overwriteFactor) &&
                parseFloat(insertData.defaultFactor) ===
                  parseFloat(insertData.overwriteFactor)
                  ? undefined
                  : 'red',
            }}
          />
        </Tooltip>
        <Tooltip title="Duration Hours">
          <Input
            // disabled
            placeholder="Duration Hours"
            value={
              isNaN(insertData.durHr)
                ? 0
                : parseFloat(insertData.durHr).toFixed(2)
            }
          />
        </Tooltip>
        <Tooltip title="MWH">
          <Input
            // disabled
            placeholder="MWH"
            value={insertData.mwh}
          />
        </Tooltip>
        <Button
          type="primary"
          disabled={mode === 'D' || mode === 'V'}
          onClick={_ => {
            if (!insertData.spillStartMod) {
              message.info('Please, Select Start Date')
              return
            }
            if (!insertData.spillEndMod) {
              message.info('Please, Select End Date')
              return
            }
            if (
              moment(
                insertData.spillStartModDate || insertData.spillStartMod
              ).isAfter(
                moment(insertData.spillEndModDate || insertData.spillEndMod)
              )
            ) {
              message.info('Please, Select valid date range.')
              return
            }

            const newSpill = {
              unitId: unit,
              utility,
              unit: unit.substr(3),
              year,
              eventNum,
              ...insertData,
              // durHr,
            }
            const nEditInfo = addRow({ editInfo, editedRow: newSpill })

            setEditInfo(nEditInfo)

            const defaultFactor = getFactorBySpillDate(
              moment(
                insertData.spillEndModDate || insertData.spillEndMod
              ).format('YYYY-MM-DDTHH:mm:ss.SSS')
            )

            setInsertData({
              visible: true,
              spillStartMod: insertData.spillEndMod,
              spillStartModDate: moment(insertData.spillEndMod),
              overwriteFactor: defaultFactor,
              defaultFactor,
            })

            handleChange({}, true)
          }}
        >
          Add New Spill
        </Button>
      </div>

      <Grid
        headers={header}
        data={spillData}
        render={virtualizedGridRenderer({
          height: height - 100,
          width: width - 5,
          cellRender,
          headerRowHeight: 30,
          rowHeaderRender,
        })}
        editInfo={editInfo}
        onEditInfoChange={editRow}
        isEditable={editable => {
          // if (
          //   disableComp
          //   // || disableCOPUEVentTypeView
          // )
          //   return false
          return editable.header.editable || false
        }}
        editMode="cell"
        onSelectionChange={rows => {
          setSelectedRows(rows)
        }}
        selectionMode="single"
        selectionType="row"
        sortOptions={header}
        initialSortOptions={header}
        // sortEnabled={false}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  units: getUnits(state),
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SpillTable)

const header = [
  // utilityReqHeader,
  // unitIdHeader,
  // strCol({
  //   ident: 'utility',
  //   display: 'Utility',
  //   width: 100,
  //   isKey: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'unitId',
  //   display: 'unit',
  //   width: 100,
  //   isRequired: true,
  //   sortOrder: 'asc',
  // }),
  // intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  // intCol({
  //   ident: 'eventNum',
  //   display: 'Event Number',
  //   isKey: true,
  //   width: 60,
  // }),

  // strCol({
  //   ident: 'spillStart',
  //   display: 'Start',
  //   width: 250,
  //   isKey: true,
  // }),

  strCol({
    ident: 'spillStartMod',
    display: 'Start (mm/dd/yyyy hh:mm)',
    width: 250,
    displayFormat: 'MM/DD/YYYY HH:mm',
    editable: true,
    sortIndexGetter: ({ rowData }) => {
      const v = moment(rowData.spillStartMod, 'MM/DD/YYYY HH:mm').format(
        'YYYYMMDDHHmmss'
      )
      return v
    },
    sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'spillEnd',
  //   display: 'end',
  //   width: 200,
  //   isKey: true,
  // }),

  strCol({
    ident: 'spillEndMod',
    display: 'End (mm/dd/yyyy hh:mm)',
    width: 250,
    displayFormat: 'MM/DD/YYYY HH:mm',
    editable: true,
    sortIndexGetter: ({ rowData }) => {
      return moment(rowData.spillEndMod, 'MM/DD/YYYY HH:mm').format(
        'YYYYMMDDHHmmss'
      )
    },
    sortOrder: 'asc',
  }),

  numCol({
    ident: 'flowRate',
    display: 'Flow Rate/Hr',
    displayFormat: '0.0000',
    editable: true,
  }),
  numCol({
    // ident: 'defaultFactor',
    ident: 'overwriteFactor',
    display: 'eFactor',
    displayFormat: '0.0000',
    editable: true,
  }),
  numCol({
    ident: 'durHr',
    display: 'Duration Hours',
    displayFormat: '0.00',
    editable: false,
  }),
  numCol({ ident: 'mwh', display: 'MWH', editable: false }),
]
